import React from 'react';

// Kept outside a closed desktop popover as well as inside the mobile card:
// a failed autosave must leave a visible, deliberate recovery action.
export default function DesignerNoteStatus({ note, testId }) {
  const { message, saving, checking, canRetry, needsCheck, readOnly, retrySave, checkSavedNote } = note;
  if (!message && !saving && !checking) return null;

  return (
    <div className="space-y-2 text-xs text-stone-600" data-testid={`${testId}-status`}>
      <p role="status" aria-live="polite">
        {saving ? 'Saving…' : checking ? 'Checking saved note…' : message}
      </p>
      {needsCheck && (
        <button type="button" onClick={checkSavedNote} disabled={readOnly}
          className="rounded border border-stone-300 bg-white px-2 py-1 font-semibold disabled:opacity-50"
          data-testid={`${testId}-check`}>
          Check saved note
        </button>
      )}
      {canRetry && (
        <button type="button" onClick={retrySave} disabled={readOnly}
          className="rounded border border-stone-300 bg-white px-2 py-1 font-semibold disabled:opacity-50"
          data-testid={`${testId}-retry`}>
          Retry save
        </button>
      )}
    </div>
  );
}
